var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized } from '@lit/localize';
let NodeSettings = class NodeSettings extends LitElement {
    constructor() {
        super(...arguments);
        this.node = null;
    }
    preview(input_value) {
        return typeof input_value === 'object'
            ? JSON.stringify(input_value, null, 2)
            : String(input_value);
    }
    render() {
        return html `
        <div class="node-settings__columns">
          <div class="node-settings__column">
            <input-node-settings
              .node="${this.node}"
              .workflowExecutionData="${this.workflowExecutionData}"
            ></input-node-settings>
          </div>

          <div class="node-settings__column">
            <form-node-settings
              .node="${this.node}"
              .apiService="${this.apiService}"
            ></form-node-settings>
          </div>

          <div class="node-settings__column">
            <output-node-settings
              .nodeExecution="${this.workflowExecutionData?.nodes_executions?.find(ne => ne.node_id === this.node?.node_id)}"
            ></output-node-settings>
          </div>
        </div>
    `;
    }
};
NodeSettings.styles = css `
  :host {
    display: block;
    height: 100%; /* Assurez-vous que le parent a une hauteur définie */
    box-sizing: border-box;
  }

  .node-settings__header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 8px;
  }

  .node-settings__icon {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .node-settings__title {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
  }

  /* =====================
     Columns (minimal)
     ===================== */

  .node-settings__columns {
    display: flex;
    align-items: stretch;
    height: 100%;
  }

    .node-settings__column {
      box-sizing: border-box;
      padding: 12px;
      flex: 1;
      min-width: 0;
    }

  .node-settings__column + .node-settings__column {
    border-left: 1px solid #ddd;
  }
`;
__decorate([
    property({ type: Object })
], NodeSettings.prototype, "node", void 0);
__decorate([
    property({ type: Object })
], NodeSettings.prototype, "apiService", void 0);
__decorate([
    property({ type: Object })
], NodeSettings.prototype, "workflowExecutionData", void 0);
NodeSettings = __decorate([
    localized(),
    customElement('node-settings')
], NodeSettings);
export { NodeSettings };
//# sourceMappingURL=NodeSettings.js.map